(function () {
  "use strict";
  if (window.__fmQuizProgressiveBound) return;
  window.__fmQuizProgressiveBound = true;

  function enhance(wrapper) {
    if (wrapper.dataset.fmQuizEnhancing) return;
    var fallback = wrapper.querySelector("[data-fm-quiz-fallback]");
    var host = wrapper.querySelector("[data-furrmacy-longevity-quiz]");
    if (!fallback || !host) return;
    wrapper.dataset.fmQuizEnhancing = "true";
    var observer;
    var timer;

    function handOff() {
      // A script download alone is not readiness: wait for the App's real UI.
      if (!host.querySelector(".flq-shell")) return false;
      fallback.remove();
      if (observer) observer.disconnect();
      if (timer) window.clearTimeout(timer);
      return true;
    }

    if (handOff()) return;
    observer = new MutationObserver(handOff);
    observer.observe(host, { childList: true, subtree: true });
    timer = window.setTimeout(function () {
      if (handOff()) return;
      var notice = fallback.querySelector("[data-fm-quiz-load-error]");
      if (notice) notice.hidden = false;
      // Keep observing: a late App load must still replace the fallback.
    }, 12000);
  }

  function mount() {
    document.querySelectorAll("[data-fm-quiz-progressive]").forEach(enhance);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mount, { once: true });
  } else {
    mount();
  }
  document.addEventListener("shopify:section:load", mount);
})();
